<template>
	<el-dialog v-model="props.showDialog" @open="setDefault" @close="closeDialog" :title="$t('mainLayout.report.exportReport')" width="800px"
		append-to-body>
		<el-form label-width="120px" class="platForm" :rules="state.rules" :model="state.form" ref="formRef">
			<el-form-item :label="$t('component.vue.exportFormat')" prop="FormatType">
				<el-select v-model="state.form.FormatType">
					<el-option v-for="item in FormatType" :key="item.value" :value="item.value" :label="item.label" />
				</el-select>
			</el-form-item>
			<el-form-item :label="$t('common.startTime')" prop="StartTime">
				<el-date-picker type="datetime" :placeholder="$t('common.selectToolTip')" :teleported="false"
					style="width:100%" v-model="state.form.StartTime" format="YYYY-MM-DD HH:mm:ss"
					value-format="YYYY-MM-DD HH:mm:ss" />
			</el-form-item>
			<el-form-item :label="$t('common.endTime')" prop="EndTime">
				<el-date-picker type="datetime" :placeholder="$t('common.selectToolTip')" :teleported="false"
					style="width:100%" v-model="state.form.EndTime" format="YYYY-MM-DD HH:mm:ss"
					value-format="YYYY-MM-DD HH:mm:ss" />
			</el-form-item>
			<el-form-item :label="$t('alarmPro.reportTemplate')" prop="TemplateType">
				<el-select v-model="state.form.TemplateType">
					<el-option v-for="item in ReportOption" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
			</el-form-item>
		</el-form>
		<template #footer>
			<span class="dialog-footer">
				<el-button type="primary" @click="exportReport">{{ $t('common.confirm') }}</el-button>
				<el-button @click="cancel">{{ $t('common.cancel') }}</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import axios from "@common/js/axios";
import store from "@common/js/store";
import dayjs from "dayjs";
import { alertSuccessMsg, alertErrorMsg, i18nGlobal } from "@common/js/utils";
import { genneralValidate } from "@common/js/rules";

const props = defineProps({
	showDialog: {
		type: Boolean,
		default: false,
	},
});
const formRef = ref(null);
const state = reactive({
	form: {
		FormatType: 1,
		StartTime: dayjs(new Date()).format("YYYY-MM-DD") + " 00:00:00",
		EndTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
		TemplateType: 1
	},
	rules: {
		FormatType: genneralValidate(i18nGlobal('common.selectToolTip'), "change"),
		StartTime: genneralValidate(i18nGlobal('common.selectToolTip'), "change"),
		EndTime: genneralValidate(i18nGlobal('common.selectToolTip'), "change"),
		TemplateType: genneralValidate(i18nGlobal('common.selectToolTip'), "change"),
	}
});

const FormatType = [
	{
		label: "word",
		value: 1,
	}
];

const ReportOption = [
	{
		label: i18nGlobal('alarmPro.deviceReport'),
		value: 1,
	},
	{
		label: i18nGlobal('alarmPro.alarmReport'),
		value: 2,
	}
]

const emit = defineEmits(["close"]);

const exportReport = () => {
	formRef.value?.validate((valid) => {
		if (!valid) return;
		if (state.form.StartTime && state.form.EndTime) {
			const isBefore = dayjs(state.form.StartTime).isBefore(dayjs(state.form.EndTime));
			if (!isBefore) {
				return alertErrorMsg(i18nGlobal('common.startTimeLessThanEndTime1'));
			}
			axios({
				method: "post",
				url: "Report/export-report",
				data: {
					Path: store.state.currentDep.Path,
					...state.form,
					StartTime: dayjs(state.form.StartTime).format("YYYY-MM-DD HH:mm:ss"),
					EndTime: dayjs(state.form.EndTime).format("YYYY-MM-DD HH:mm:ss")
				},
			}).then((res) => {
				if (res.IsSuccess) {
					alertSuccessMsg(i18nGlobal('common.exportSuccess'));
				}
			});
			emit('close')
			window.Header.showExportTasks();
		}
	})
}

const closeDialog = () => {
	emit("close");
};

const cancel = () => {
	emit("close");
};

const setDefault = () => {
	state.form = {
		FormatType: 1,
		StartTime: dayjs(new Date()).format("YYYY-MM-DD") + " 00:00:00",
		EndTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
		TemplateType: 1
	}
}

</script>

<style scoped lang="less"></style>
